import React, { useEffect, useState } from 'react';
import { useDebounce } from 'use-debounce';
import Parse from 'html-react-parser';

//componentes
import { PPDropDown, PPTextField } from 'processor-plataform-ui';
import Modal from '../../../../components/Dialog/Modal';
import LcIconLink from '../../../../components/Generic/LcIconLink';
import LcDropDown from '../../../../components/Generic/LcDropDown';

//Service
import ClassificationGroupService from '../../../../services/ClassificationGroupService/ClassificationGroupService';
import ClassificationService from '../../../../services/ClassificationService/ClassificationService';
import BusinessAreaService from '../../../../services/BusinessAreaService/BusinessAreaService';
import ServiceGroupService from '../../../../services/ServiceGroupService/ServiceGroupService';
import ServiceService from '../../../../services/ServiceService/ServiceService';
import ProcessService from '../../../../services/ProcessService/ProcessService';
import ModeOpeningService from '../../../../services/ModeOpeningService/ModeOpeningService';
import SolicitationService from '../../../../services/SolicitationService/SolicitationService';
import { ServiceGroupSearch } from '../../../../models/ServiceGroupSearch';
import WorkService from '../../../../services/WorkService/WorkService';
import FastSolicitationService from '../../../../services/FastSolicitationService/FastSolicitationService';
import TextTools from '../../../../services/TextTools/TextTools';

//Models
import { SolicitationUrgencyPortugues } from '../../../../models/solicitation';
import { SolicitationView } from '../../../../models/SolicitationView';
import LcLoading from '../../../../components/Generic/LcLoading';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import { UserState } from '../../../../store/reducers/userReducer';
import { escapeRegExp } from 'lodash';

interface Props {
    solicitation: SolicitationView,
    user: any,
    submitClassification: Function
}

const SolicitationClassification: React.FC<Props> = (props) => {

    const mountDropListFromEnum = (data) => {
        let result = [{ label: '...', value: "0" }];
        for (let i = 0; i < Object.keys(data).length / 2; i++) {
            result.push({ label: Object.keys(data)[i + 4], value: Object.keys(data)[i] })
        }
        return result;
    }
    const [modalVisible, setModalVisible] = useState(false);
    const user = useSelector<RootState, UserState>(state => state.user);
    const classificationGroupService = new ClassificationGroupService(props);
    const classificationService = new ClassificationService(props);
    const businessArea = new BusinessAreaService(props);
    const serviceGroupService = new ServiceGroupService(props);
    const serviceService = new ServiceService(props);
    const processService = new ProcessService(props);
    const modeOpeningService = new ModeOpeningService(props);
    const solicitationService = new SolicitationService(props);
    const workService = new WorkService(props);
    const fastSolicitationService = new FastSolicitationService(props);
    const util = new TextTools();

    // const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);

    //Lista form
    const [businessAreaList, setBusinessAreaList] = useState<any[]>([]);
    const [serviceGroupList, setServiceGroupList] = useState<any[]>([]);
    const [serviceList, setServiceList] = useState<any[]>([]);
    const [processList, setProcessList] = useState<any[]>([]);
    const [classifications, setClassifications] = useState<any[]>([]);
    const [classificationsGroup, setClassificationsGroup] = useState<any[]>([]);
    const [modeOpeningList, setModeOpeningList] = useState<any[]>([]);
    const [solicitationUrgencyPortuguesList] = useState<any[]>(mountDropListFromEnum(SolicitationUrgencyPortugues));

    const dataToSendDefault = {
        id: props.solicitation.id,
        idBusinessArea: props.solicitation.idBusinessArea,
        idServiceGroup: props.solicitation.idServiceGroup || 0,
        idService: props.solicitation.idService,
        idProcess: props.solicitation.idProcess,
        idContract: props.solicitation.idContract || 0,
        idClassification: props.solicitation.idClassification || 0,
        idClassificationGroup: props.solicitation.idClassificationGroup || 0,
        idResponsibleUser: Number(props.solicitation.idResponsibleUser) || Number(user.id),
        urgency: props.solicitation.urgency,
        idOpenMode: props.solicitation.idOpenMode || 0,
        idUserRequester: Number(props.solicitation.idUserRequester),
        idUserChange: Number(props.user.id),
    }

    const [dataToSendAux, setDataToSendAux] = useState(dataToSendDefault);
    const [dataToSend, setDataToSend] = useState(dataToSendDefault);
    const [loadingClassifications, setLoadingClassifications] = useState<boolean>(false);

    const [search, setSearch] = useState<string>("");
    const [searchDebounce] = useDebounce(search, 300);
    const [searchResult, setSearchResult] = useState<ServiceGroupSearch[]>([]);
    const [loadingLabel, setLoadingLabel] = useState<boolean>(true);
    const [allProcessList, setAllProcessList] = useState<any[]>([]);
    const [showOptionWork, setShowOptionWork] = useState<boolean>(false);
    const [loadingNewWork, setLoadingNewWork] = useState<boolean>(false);

    const init = () => {
        setSearchResult([]);
        setSearch("");
        setDisableButton(true);
    }

    const searchSelection = (result: ServiceGroupSearch) => {
        getServiceBusca(result);
    };

    const getServiceBusca = async (result: ServiceGroupSearch) => {
        setDataToSend({
            ...dataToSend,
            idBusinessArea: result.id_area_negocio,
            idServiceGroup: result.id_grupo_servico,
            idService: result.id_servico,
            idProcess: result.id_processo,
            idClassificationGroup: result.id_grupo_classificacao,
            idClassification: result.id_classificacao,
        });
    };

    const handleOnchangeSearch = (e: any) => setSearch(e.target.value);

    useEffect(() => {
        init();
    }, [modalVisible]);

    useEffect(() => {
        if (searchDebounce !== "") searchKeyWords(searchDebounce);
        else setSearchResult([]);
    }, [searchDebounce]);

    const searchKeyWords = async (search: string) => {
        setLoadingLabel(true);

        try {
            const idCustomer_ = ((props.solicitation.idCustomer !== 0) ? props.solicitation.idCustomer : user.defaultCustomer.id);
            const serviceGroupResponse = await serviceGroupService.GetClassificationViewTreeTag(Number(props.solicitation.idUserRequester), search, idCustomer_);
            setSearchResult(serviceGroupResponse.data);
        }
        catch (error) {
            debugger;
        }

        setLoadingLabel(false);
    };

    useEffect(() => {
        fecthData();
    }, [modalVisible])

    const fecthData = async () => {
        try {
            setLoadingClassifications(true);
            // setLoading(true);

            // setBusinessAreaList([]);
            // setServiceGroupList([]);
            // setServiceList([]);
            // setProcessList([]);
            // setClassificationsGroup([]);
            // setClassifications([]);

            //Inicializados sem dados
            var p1 = businessArea.getByUserId(props.solicitation.idUserRequester)
                .then(response => {
                    setBusinessAreaList(mountDropList(response.data));
                })
                .catch(console.warn)

            // var p2 = serviceGroupService.getByUserId(props.solicitation.idUserRequester, props.solicitation.idBusinessArea, props.solicitation.idCustomer)
            //     .then(response => {
            //         console.log(response)
            //         response.data.length > 0 && setServiceGroupList(mountDropList(response.data));
            //     })
            //     .catch(console.warn)

            Promise.all([p1])
                .then(() => {
                    // setLoading(false);
                })

            // loadClassificationsGroup();
            // loadClassifications();
            loadModeOpeningList();

            setLoadingClassifications(false);
        }
        catch (error) {
            console.warn(error)
        }
    }

    const loadServiceGroupList = async () => {
        try {
            // const serviceGroupResponse = await serviceGroupService.getByUserId(props.solicitation.idUserRequester, dataToSend.idBusinessArea, props.solicitation.idCustomer);
            const serviceGroupResponse = await serviceGroupService.getByUserAttendantId(props.solicitation.idUserRequester, dataToSend.idBusinessArea, props.solicitation.idCustomer);
            setServiceGroupList(mountDropList(serviceGroupResponse.data));
        }
        catch (error) {
            console.warn(error)
        }
    }

    const loadServiceList = async () => {
        try {
            const serviceResponse = await serviceService.GetServiceByRequesterIdAndSolicitationGroupId(dataToSend.idUserRequester, dataToSend.idServiceGroup);
            setServiceList(mountDropList(serviceResponse.data));
        }
        catch (error) {
            console.warn(error)
        }
    }

    const loadProcessList = async () => {
        try {
            // const processResponse = await processService.getByUserId(props.solicitation.idUserRequester, dataToSend.idBusinessArea, props.solicitation.idCustomer, dataToSend.idServiceGroup, dataToSend.idService);
            const processResponse = await processService.getProcessbyService(dataToSend.idService);
            let optionsDropDown = mountDropList(processResponse.data);

            // let processList_ = optionsDropDown;
            // const listaComMajor = optionsDropDown.filter(x => x.label === "MAJOR INCIDENT");

            // if (listaComMajor.length === 0) {
            //     processList_ = [...processList_, { label: 'MAJOR INCIDENT', value: 373 }];
            // }

            setProcessList(optionsDropDown);
            setAllProcessList(processResponse.data);
        }
        catch (error) {
            console.warn(error);
        }
    }

    const loadClassificationsGroup = async () => {
        try {
            const classificationGroupResponse = await classificationGroupService.getClassificationGroupByService(dataToSend.idService);
            const data = await classificationGroupResponse.data.filter(x => x.idBusinessArea === dataToSend.idBusinessArea);
            setClassificationsGroup(mountDropList(data));
        }
        catch (error) {
            console.warn(error);
        }
    }

    const loadClassifications = async () => {
        try {
            const classificationResponse = await classificationService.getClassificationByService(dataToSend.idService, dataToSend.idClassificationGroup);
            setClassifications(mountDropList(classificationResponse.data));
        }
        catch (error) {
            console.warn(error);
        }
    }

    const loadModeOpeningList = async () => {
        try {
            const modeOpeningResponse = await modeOpeningService.getModeOpening(dataToSend.idBusinessArea);
            setModeOpeningList(mountDropList(modeOpeningResponse.data));
        }
        catch (error) {
            console.warn(error);
        }
    }

    useEffect(() => {
        // setServiceGroupList([])
        loadServiceGroupList();
        loadModeOpeningList()
        if (dataToSend.idBusinessArea !== props.solicitation.idBusinessArea) {
            setDataToSend({
                ...dataToSend,
                idServiceGroup: 0,
                idService: 0,
                idProcess: 0,
                idClassification: 0,
                idClassificationGroup: 0,
            })
        }
    }, [dataToSend.idBusinessArea])

    useEffect(() => {
        setServiceList([])

        loadServiceList()
    }, [dataToSend.idServiceGroup, dataToSend.idBusinessArea])

    useEffect(() => {
        setProcessList([])

        loadProcessList();
    }, [dataToSend.idService, dataToSend.idServiceGroup])

    useEffect(() => {
        setClassificationsGroup([])

        loadClassificationsGroup();
    }, [dataToSend.idProcess, dataToSend.idService])

    useEffect(() => {
        setClassifications([])
        loadClassifications();
    }, [dataToSend.idClassificationGroup, dataToSend.idService,])

    // useEffect(() => {
    //     if (businessAreaList.length > 0 && serviceGroupList.length > 0 && serviceList.length > 0 && processList.length > 0 && classificationsGroup.length > 0 && classifications.length > 0) {
    //         let dataToSendTemp = dataToSend;

    //         if (props.solicitation.idBusinessArea) {
    //             dataToSendTemp = { ...dataToSendTemp};
    //         } else {
    //             dataToSendTemp = { ...dataToSendTemp, idBusinessArea: businessAreaList[0].value };
    //         }
    //         if (props.solicitation.idServiceGroup ) {
    //             dataToSendTemp = { ...dataToSendTemp};
    //         } else {
    //             dataToSendTemp = { ...dataToSendTemp, idServiceGroup: serviceGroupList[0].value };
    //         }

    //         if (props.solicitation.idService) {
    //             dataToSendTemp = { ...dataToSendTemp};
    //         } else {
    //             dataToSendTemp = { ...dataToSendTemp, idService: serviceList[0].value };

    //         }

    //         if (props.solicitation.idProcess) {
    //             dataToSendTemp = { ...dataToSendTemp};
    //         } else {
    //             dataToSendTemp = { ...dataToSendTemp, idProcess: processList[0].value };
    //         }

    //         if (props.solicitation.idClassificationGroup) {
    //             dataToSendTemp = { ...dataToSendTemp};
    //         } else {
    //             dataToSendTemp = { ...dataToSendTemp, idClassificationGroup: classificationsGroup[0].value };

    //         }

    //         if (props.solicitation.idClassification) {
    //             dataToSendTemp = { ...dataToSendTemp};
    //         } else {
    //             dataToSendTemp = { ...dataToSendTemp, idClassification: classifications[0].value };

    //         }

    //         setDataToSend(dataToSendTemp);
    //     }
    // }, [businessAreaList, serviceGroupList, serviceList, processList, classificationsGroup, classifications, props.solicitation, dataToSend ]);

    const mountDropList = (list: any[]) => {
        let result = (list.length !== 1) ? [] : [{ label: '...', value: 0 }];

        if (list.length > 0) {
            let _list = list.filter(c => c.disabled === 0 || c.disabled === false)
                .map(c => { return { label: (c.name) ? c.name : c.description, value: c.id } })
                // .sort((a, b) => { return a.label.toLower() > b.label.toLower() ? 1 : -1 })
                .sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }));

            return _list;
        }
        else {
            return result;
        }
    }

    const submitClassification = async () => {
        setDataToSendAux(dataToSend);
        setSaving(true);

        var approval;

        try {
            await solicitationService.postSolicitationUpdate(dataToSend);

            var processSelected = allProcessList.find(x => x.id === dataToSend.idProcess);

            if (processSelected) {
                var processResponse = await workService.getApprovalListByProcessId(processSelected.id);
                approval = processResponse.data;

                if (approval && approval.optionalFirstWork && dataToSend.idProcess !== dataToSendDefault.idProcess) {
                    setShowOptionWork(true);
                }
            }
        }
        catch (error) {
            console.log(error);
        }

        if (!approval) {
            props.submitClassification();
        }

        setSaving(false);
        setModalVisible(false);
    }

    const handleNewWork = async () => {
        setLoadingNewWork(true);

        try {
            await fastSolicitationService.NewFastWorkAndSLABySolicitationId(props.solicitation.id);
            setShowOptionWork(false);
        }
        catch (error) {
            debugger;
        }

        props.submitClassification();
        setLoadingNewWork(false);
    }

    const handleChange = (event: any) => {
        const { name, value } = event.target;
        setDataToSend({ ...dataToSend, [name]: Number(value) });
    }

    const handleCloseModal = () => {
        if (dataToSendAux !== dataToSend) {
            setDataToSend({
                id: props.solicitation.id,
                idBusinessArea: props.solicitation.idBusinessArea,
                idServiceGroup: props.solicitation.idServiceGroup || 0,
                idService: props.solicitation.idService,
                idProcess: props.solicitation.idProcess,
                idContract: props.solicitation.idContract || 0,
                idClassification: props.solicitation.idClassification || 0,
                idClassificationGroup: props.solicitation.idClassificationGroup || 0,
                idResponsibleUser: Number(props.solicitation.idResponsibleUser),
                urgency: props.solicitation.urgency,
                idOpenMode: props.solicitation.idOpenMode || 0,
                idUserRequester: Number(props.solicitation.idUserRequester),
                idUserChange: Number(props.user.id)
            });
        }

        init();
        setModalVisible(false);
    }

    // useEffect(() => {
    //     if (!modalVisible && dataToSendAux !== dataToSend) {
    //         fecthData();
    //     }
    // }, [modalVisible, dataToSend, dataToSendAux])

    const [disableButton, setDisableButton] = useState(false);

    useEffect(() => {
      if (util.compareObjects(dataToSendDefault, dataToSend)) {
        setDisableButton(true);
      }
      else {
        setDisableButton(false);
      }
    }, [dataToSend])

    useEffect(() => {
      if (dataToSend.idProcess === dataToSendDefault.idProcess) {

      }
    }, [dataToSend.idProcess])
    

    return (
        <div className='form'>
            <LcLoading loading={loadingClassifications} label='Carregando...'>
                <div className="row start">
                    <div className='inputClassification' style={{ width: "calc(100% - 36px)", padding: '0px' }}>
                        <PPTextField readOnly type="text" value={
                            (businessAreaList.find(o => Number(o.value) === dataToSend.idBusinessArea)?.label || '...') + " / " +
                            (serviceGroupList.find(o => Number(o.value) === dataToSend.idServiceGroup)?.label || '...') + " / " +
                            (serviceList.find(o => Number(o.value) === dataToSend.idService)?.label || '...') + " / " +
                            (processList.find(o => Number(o.value) === dataToSend.idProcess)?.label || '...') + " / " +
                            (classificationsGroup.find(o => Number(o.value) === dataToSend.idClassificationGroup)?.label || '...') + " / " +
                            (classifications.find(o => Number(o.value) === dataToSend.idClassification)?.label || '...') + " / " +
                            (solicitationUrgencyPortuguesList.find(o => Number(o.value) === dataToSend.urgency)?.label || '...') + " / " +
                            (modeOpeningList.find(o => Number(o.value) === dataToSend.idOpenMode)?.label || '...')
                        } />
                    </div>

                    {
                        props.solicitation.idStatus === 8 || props.solicitation.idStatus === 6
                            ? <LcIconLink icon='ppi ppi-eye' tooltip="Visualizar Classificação" tooltipPosition="fullLeft" onClick={() => { setModalVisible(true); }} />
                            : <LcIconLink icon='ppi ppi-pencil' tooltip="Editar" onClick={() => { setModalVisible(true); }} />

                    }
                    <Modal
                        visible={modalVisible}
                        close={() => handleCloseModal()}
                        title="Classificação do chamado"
                    >

                        <div style={{ marginTop: "60px" }} />
                        <LcLoading loading={saving} label='Carregando...'>
                            <div className='form'>
                                <div className='divSearchTemplateCall'>
                                    <div className="input-4 label"> Pesquisar </div>
                                    <LcDropDown
                                        element={
                                            <div style={{ width: "35rem", maxHeight: "400px", overflowX: "hidden" }}>
                                                <PPTextField
                                                    placeholder={"Grupo, serviço, assunto..."}
                                                    onChange={handleOnchangeSearch}
                                                    value={search}
                                                    disabled={props.solicitation.idStatus === 8 || props.solicitation.idStatus === 6}
                                                    autoComplete="off"
                                                />
                                            </div>
                                        }
                                        width={"560px"}
                                        maxHeight={"400px"}
                                        onEnterClose={true}
                                        trigger={"keyPress"}
                                        disabled={props.solicitation.idStatus === 8 || props.solicitation.idStatus === 6}
                                        visible={search.length > 0}
                                    >
                                        {
                                            searchResult.length === 0 && search !== ""
                                                ? <span className="item"> {loadingLabel ? 'Carregando...' : 'Nenhum resultado encontrado...'}</span>
                                                : <div style={{ display: "flex", flexDirection: "column" }}>
                                                    {
                                                        searchResult && searchResult
                                                            .slice(0, 10)
                                                            .map(result => {
                                                                return (
                                                                    <>
                                                                        <span
                                                                            className={"spanLabel"}
                                                                            style={{ marginBottom: "10px", cursor: "pointer" }}
                                                                            onClick={() => searchSelection(result)}
                                                                        >
                                                                            {
                                                                                (() => {
                                                                                    let temp = result.path;

                                                                                    var result_ = '';

                                                                                    if (typeof temp === 'string' && typeof search === 'string') {
                                                                                        var searchMask = escapeRegExp(search);
                                                                                        var regEx = new RegExp(searchMask, "ig");
                                                                                        var replaceMask = `<b>${searchMask}</b>`;

                                                                                        result_ = temp.replace(regEx, replaceMask);
                                                                                    }

                                                                                    return <>{Parse(result_)}</>;
                                                                                })()
                                                                            }
                                                                        </span>
                                                                    </>
                                                                );
                                                            })
                                                    }
                                                </div>
                                        }
                                    </LcDropDown>
                                    <div style={{ marginBottom: "20px" }} />
                                </div>

                                <div className="row start">
                                    <div className="input-4 label">Área de negócio</div>
                                    <div className="input-8">
                                        <PPDropDown
                                            openTrigger='click'
                                            value={businessAreaList.length && dataToSend.idBusinessArea > 0 ? dataToSend.idBusinessArea : ""}
                                            name="idBusinessArea"
                                            onChange={handleChange}
                                            options={businessAreaList}
                                            placeholder={'Área de negócio'}
                                            placeholderSearch={'Buscar área de negócio'}
                                            disabled={props.solicitation.idStatus === 8 || props.solicitation.idStatus === 6}
                                        />
                                    </div>
                                </div>
                                <div className="row start">
                                    <div className="input-4 label">Grupo de serviço</div>
                                    <div className="input-8">
                                        <PPDropDown
                                            openTrigger='click'
                                            value={serviceGroupList.length && dataToSend.idServiceGroup > 0 ? dataToSend.idServiceGroup : ""}
                                            name="idServiceGroup"
                                            onChange={handleChange}
                                            options={serviceGroupList}
                                            placeholder={'Grupo de serviço'}
                                            placeholderSearch={'Buscar grupo de serviço'}
                                            disabled={props.solicitation.idStatus === 8 || props.solicitation.idStatus === 6}
                                        />
                                    </div>
                                </div>
                                <div className="row start">
                                    <div className="input-4 label">Serviço</div>
                                    <div className="input-8">
                                        <PPDropDown
                                            openTrigger='click'
                                            value={serviceList.length && dataToSend.idService > 0 ? dataToSend.idService : ""}
                                            name="idService"
                                            onChange={handleChange}
                                            options={serviceList}
                                            placeholder={'Serviço'}
                                            placeholderSearch={'Buscar serviço'}
                                            disabled={props.solicitation.idStatus === 8 || props.solicitation.idStatus === 6}
                                        />
                                    </div>
                                </div>
                                <div className={"row start"}>
                                    <div className={"input-4 label"}>Processo</div>
                                    <div className={"input-8"}>
                                        <PPDropDown
                                            openTrigger={'click'}
                                            value={processList.length && dataToSend.idProcess > 0 ? dataToSend.idProcess : ""}
                                            name={"idProcess"}
                                            onChange={handleChange}
                                            options={processList}
                                            placeholder={'Processo'}
                                            placeholderSearch={'Buscar Processo'}
                                            disabled={props.solicitation.idStatus === 8 || props.solicitation.idStatus === 6}
                                        />
                                    </div>
                                </div>
                                <div className={"row start"}>
                                    <div className={"input-4 label"}>Grupo de classificação</div>
                                    <div className={"input-8"}>
                                        <PPDropDown
                                            openTrigger={'click'}
                                            value={classificationsGroup.length && dataToSend.idClassificationGroup > 0 ? dataToSend.idClassificationGroup : ""}
                                            name={"idClassificationGroup"}
                                            onChange={handleChange}
                                            options={classificationsGroup}
                                            placeholder={'Grupo de classificação'}
                                            placeholderSearch={'Buscar grupo de classificação'}
                                            disabled={props.solicitation.idStatus === 8 || props.solicitation.idStatus === 6}
                                        />
                                    </div>
                                </div>
                                <div className={"row start"}>
                                    <div className={"input-4 label"}>Classificação</div>
                                    <div className={"input-8"}>
                                        <PPDropDown
                                            openTrigger={'click'}
                                            value={classifications.length && dataToSend.idClassification > 0 ? dataToSend.idClassification : ''}
                                            name="idClassification"
                                            onChange={handleChange}
                                            options={classifications}
                                            placeholder={'Classificação'}
                                            placeholderSearch={'Buscar classificação'}
                                            disabled={props.solicitation.idStatus === 8 || props.solicitation.idStatus === 6}
                                        />
                                    </div>
                                </div>
                                <div className={"row start"}>
                                    <div className={"input-4 label"}>Urgência</div>
                                    <div className={"input-8"}>
                                        <PPDropDown
                                            openTrigger={'click'}
                                            value={solicitationUrgencyPortuguesList.length && dataToSend.urgency > 0 ? dataToSend.urgency.toString() : ""}
                                            name={"urgency"}
                                            onChange={handleChange}
                                            options={solicitationUrgencyPortuguesList}
                                            placeholder={'Urgência'}
                                            placeholderSearch={'Buscar urgência'}
                                            disabled={props.solicitation.idStatus === 8 || props.solicitation.idStatus === 6}
                                        />
                                    </div>
                                </div>
                                <div className={"row start"}>
                                    <div className="input-4 label">Origem do atendimento</div>
                                    <div className="input-8">
                                        <PPDropDown
                                            openTrigger={'click'}
                                            value={modeOpeningList.length && dataToSend.idOpenMode > 0 ? dataToSend.idOpenMode : ""}
                                            name={"idOpenMode"}
                                            onChange={handleChange}
                                            options={modeOpeningList}
                                            placeholder={'Origem do atendimento'}
                                            placeholderSearch={'Buscar Origem do atendimento'}
                                            disabled={props.solicitation.idStatus === 8 || props.solicitation.idStatus === 6}
                                        />
                                    </div>
                                </div>
                                <div className="commands">
                                    <button type="submit" disabled={props.solicitation.idStatus === 8 || props.solicitation.idStatus === 6 || saving || disableButton} className='lc-button bg-info' onClick={() => { !saving && submitClassification() }}>{'Ok'}</button>
                                    <button type='reset' disabled={saving} className='lc-button bg-info-alt' onClick={() => { !saving && handleCloseModal() }}> Cancelar </button>
                                </div>
                            </div>
                        </LcLoading>
                        {/* {
                            loadingDataForm &&
                            <i className="ppi ppi-cog ppi-spin ppi-5x" />
                        } */}
                    </Modal>

                    <Modal
                        title={'Novo Trabalho'}
                        visible={showOptionWork}
                        close={() => setShowOptionWork(false)}
                    >
                        <LcLoading loading={loadingNewWork} label={'Carregando...'}>
                            <div className={'form'}>
                                <span style={{ fontSize: "15px", marginLeft: '-3px' }}>Iniciar um fluxo de trabalho de aprovação para esta solicitação?</span>
                                <div className={'commands'}>
                                    <button type={'button'} className={'lc-button bg-info'} onClick={() => handleNewWork()} style={{ marginRight: "10px" }}> Ok </button>
                                    <button type={'button'} className={'lc-button bg-info-alt'} onClick={() => { setShowOptionWork(false); props.submitClassification(); }}> Cancelar </button>
                                </div>
                            </div>
                        </LcLoading>
                    </Modal>
                </div>
                <div className="input-12">
                    <div className="input-6">
                        <PPTextField disabled value={modeOpeningList.find(o => Number(o.value) === dataToSend.idOpenMode)?.label || '...'} label="Origem" />
                    </div>
                </div>
                <div className="input-12">
                    <div className="input-6">
                        <PPTextField disabled value={solicitationUrgencyPortuguesList.find(o => Number(o.value) === dataToSend.urgency)?.label || '...'} label="Prioridade" />
                    </div>
                </div>
            </LcLoading>
        </div>
    );
}

export default SolicitationClassification;